<template>
  <div class="screen-score-end" :class="{'filter-blur':activitymoadal==true}">
    <div class="back" @click="goBack" v-if="scoreModel.status != 1">&lt;{{ $t("system.back") }}</div>
    <div class="student-list-wra">
      <p class="empty" v-if="endevaluate.length == 0 && !isLoading">{{ $t("grade.noEndEva") }}</p>
      <ul class="student-list" v-scrollBar>
        <li
          class="student-item clearfix"
          v-for="(item,index) in endevaluate"
          :key="'endevaluate' + index"
        >
          <span class="index">{{endevaluate.length-index}}</span>
          <div class="info clearfix">
            <img
              class="student-headImg"
              :src="getImg(item.headImage)"
              alt="student"
              v-if="scoreModel.type == 1"
            />
            <span class="name ellipsis-one" :title="item.name">{{item.name}}</span>
          </div>
          <div class="score-info clearfix">
            <span class="scored-num">{{ $t("grade.gradeNum", { num: item.markCount }) }}</span>
            <span
              class="score"
            >{{$t("grade.points", { n: item.score > 0 || item.score === 0 ? item.score : '--' })}}</span>
            <div class="action">
              <span class="iconfont icon-more"></span>
              <ul class="action-btns">
                <li @click="goDetail(item.selectId)">{{ $t("grade.evaDetail") }}</li>
                <li @click="markAgain(item.selectId)">{{ $t("grade.reMark") }}</li>
              </ul>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "score",
  props: { activitymoadal: Boolean },
  data() {
    return {
      userId: 0,
      scoreId: 0,
      scoreModel: {},
      endevaluate: [],
      evaluate: [],
      modal: false,
      isLoading: true
    };
  },
  methods: {
    //轮训查询投票详情
    getDetail() {
      var self = this;
      this.timer = setInterval(function() {
        self.getScoreDetail();
      }, 2000);
    },
    getScoreDetail() {
      var self = this;
      self.$http
        .get(
          `${self.baseURL1}/classscore/getDetail?userId=${self.userId}&id=${self.scoreId}&roleId=9`
        )
        .then(res => {
          self.scoreModel = res.data;
          self.endevaluate = res.data.endevaluate || [];
          self.evaluate = res.data.evaluate || [];
          self.$emit("pushDetial", res.data);
          self.isLoading = false;
        });
    },
    addStudent() {
      this.modal = true;
    },
    closeModal() {
      this.modal = false;
    },
    getImg(imgUrl) {
      return this.common.handleImg(imgUrl, this.rescourceURL);
    },
    goBack() {
      this.$router.replace(`/screenIndex/score`);
    },
    goDetail(id) {
      this.$router.replace(`/screenIndex/scoreDetail/${id}`);
    },
    markAgain(id) {
      this.$http
        .post(
          `${this.baseURL1}/classscore/updateEvaluationForPersonal?selectId=${id}&status=0`
        )
        .then(res => {
          this.$http
            .post(
              `${this.baseURL1}/classscore/updateClassScoreStatus?id=${this.scoreId}&status=0`
            )
            .then(res => {
              this.getScoreDetail();
            });
        });
    }
  },
  created: function() {
    this.userId = this.common.getCookie("userId");
    this.scoreId = this.common.getCookie("activityId");
    this.getScoreDetail();
    this.getDetail();
  },
  computed: {},
  watch: {},
  mounted: function() {},
  beforeDestroy() {
    clearInterval(this.timer);
    this.timer = null;
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "scoreEndList.scss";
</style>



// WEBPACK FOOTER //
// src/components/scoreEndList/scoreEndList.vue